<template>
  <div v-if="visible" class="onekey-drawer">
    <div>
      <span style="display:inline-block;border-left:3px solid #698cad;padding-left:5px;font-size:16px">{{ title }}</span>
      <span v-if="onkeyMatchMode != '智能' && onkeyMatchMode != '血库'" style="color:#666;margin-left:5px;">根据6项核心标签找到的合适人选</span>
      <i class="el-icon-close" style="float:right;font-size:16px;cursor:pointer;margin:5px" @click="visible = false"></i>
    </div>
    <radishListOnekey
      ref="radishList"
      :pid="projectId"
      :onkey-match-mode="onkeyMatchMode"
      :on-confirm="onConfirm"
    />

  </div>
</template>

<script>
import {
  getRankRange,
  getPerformance,
  getPlatform,
} from '../constant/utils.js'

const modeMap = {
  '1': '一键匹配',
  '2': '二键匹配',
  '3': '三键匹配',
  '智能': '智能匹配',
  '血库': '血库人选',
}

export default {
  data() {
    return {
      visible: false,
      projectId: '',
      onConfirm: null,
      onkeyMatchMode: '',
    }
  },
  computed: {
    title() {
      return modeMap[this.onkeyMatchMode] || ''
    }
  },
  methods: {
    closeDrawer(){
      this.visible = false
    },
    async openDrawer(params) {
      const { project, onkeyMatchMode, onConfirm, ids, xuekuCompany } = params
      app.root.$refs.CvmatchLoading.open()
      const visible = this.visible
      this.onConfirm = onConfirm
      if (visible) {
        this.visible = false
        return this.$nextTick(() => {
          this.openDrawer(params)
        })
      }
      this.projectId = (project && project._id) || ''
      this.onkeyMatchMode = onkeyMatchMode
      this.$nextTick(async () => {
        if (!this.$refs.radishList) return
        await this.$refs.radishList.init()
        if (onkeyMatchMode == '智能') {
          this.$refs.radishList.query = {_id: ids.map(i=>i.id)}
          this.$nextTick(() => {
            this.$refs.radishList.loadData()
          })
        } else {
          const fields = ['职能模块', '平台', '业绩', '职级', '地域', '细分职能']
          if (onkeyMatchMode !== '3') {
            fields.push('目标行业')
          }
          const searchData = {勿推公司: [project.客户公司]}
          if (onkeyMatchMode === '1') searchData['长期意向'] = ['Y']
          if (onkeyMatchMode === '3') project['职级'] = getRankRange(project['职级'])
          if (['2', '3'].includes(onkeyMatchMode)) {
            project['业绩'] = getPerformance(project['业绩'])
            project['平台'] = getPlatform(project['平台'])
          }
          fields.map(fieldname => {
            const value = project[fieldname]
            if (!value || value.length === 0) return
            if (fieldname === '职能模块') {
              searchData[fieldname] = [value]
            } else if (fieldname === '目标行业') {
              searchData['行业'] = value
            } else {
              searchData[fieldname] = value
            }
          })
          if (onkeyMatchMode == '血库') {
            searchData.公司 = [xuekuCompany]
          }
          this.$refs.radishList.searchData = Object.assign({}, searchData)
          await this.$refs.radishList.handleSearch()
        }

        app.root.$refs.CvmatchLoading.close()
      })
      if (!visible) this.visible = true
    },
    close() {
      this.visible = false
    },
  },
}
</script>

<style scoped>
.onekey-drawer {
  width: 80vw;
  padding: 65px 10px 0 10px;
  border: 1px solid #eaeefb;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  z-index: 1000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 0;
  /* transition: all 0.2s ease-out; */
  overflow: hidden;
  background: #E0E7EC;
}

</style>
